import React from 'react';
import { MessageBar } from '@fluentui/react';

export const getNetflixFrequencyCapping = i18n => (
  <div>
    <div>
      <MessageBar styles={{ root: { background: '#EFF6FC' } }}>
        <div>{i18n.getString(_TL_('The publisher\'s frequency limits have been applied: 3 impressions/day, 14 impressions/week, and 40 impressions/month.'))}</div>
      </MessageBar>
    </div>
  </div>
);
